export const UPDATE_USERINFO = 'updateUserInfo';